
<script>
import { AREA_PATH_CONFIG } from "../constants/mapSettings";
//<--------------------------------->
//importacion del componente tableinfo
import { mapState } from "vuex";
//<--------------------------------->
export default {
  components: {},
  props: {
    google: { type: Object, required: true },
    map: { type: Object, required: true },
    graphicPolygon: { type: Object, required: false },
  },
  data() {
    return {
      nombre_asociado: this.graphicPolygon.nombre_asociado,
      id_asociado: this.graphicPolygon.id_asociado,
      etiqueta: this.graphicPolygon.etiqueta,
      fecha: this.graphicPolygon.fecha,
      tipo: this.graphicPolygon.tipo,
      id_sig_subobjeto: this.graphicPolygon.id_sig_subobjeto,
      color: this.graphicPolygon.color,
      path: this.graphicPolygon.path,
      id: this.graphicPolygon.id,
      label: this.graphicPolygon.label,
      colorArea: this.graphicPolygon.colorArea,
      aplicaciones: this.graphicPolygon.aplicaciones,
      area: {},
      polygonCoords: [],
      marker: null,
    };
  },
  mounted() {
    this.crearPoligono();
  },

  watch: {
    graphicPolygon: function () {
      let idAnterior = this.id;
      this.path = this.graphicPolygon.path;
      this.id = this.graphicPolygon.id;
      this.label = this.graphicPolygon.label;
      this.colorArea = this.graphicPolygon.colorArea;
      this.aplicaciones = this.graphicPolygon.aplicaciones;
      this.nombre_asociado = this.graphicPolygon.nombre_asociado;
      this.id_asociado = this.graphicPolygon.id_asociado;
      this.etiqueta = this.graphicPolygon.etiqueta;
      this.fecha = this.graphicPolygon.fecha;
      this.tipo = this.graphicPolygon.tipo;
      this.id_sig_subobjeto = this.graphicPolygon.id_sig_subobjeto;
      this.color = this.graphicPolygon.color;

      if (this.id != idAnterior) {
        this.borrarPoligono();
        this.crearPoligono();
      }
    },

    colorArea: function () {
      this.area.setOptions({
        strokeColor: this.colorArea,
        fillColor: this.colorArea,
      });
    },

    label: function () {
      var label = this.marker.getLabel();
      label.text = this.label;
      this.marker.setLabel(label);

      this.$store.commit("aplicaciones/cambiarEtiqueta", {
        id_sig_subobjeto: this.id_sig_subobjeto,
        etiqueta: this.label,
      });
    },
  },

  computed: {
    ...mapState(["idAreaPoligono"]),
  },

  methods: {
    crearPoligono() {
      //<----Calcular  area y pintarla ----->
      if (this.colorArea != undefined) {
        this.area = new google.maps.Polygon({
          path: this.path,
          map: this.map,
          id: this.id,
          label: this.label,

          clickable: true,

          geodesic: true,
          strokeColor: this.colorArea,
          strokeOpacity: 1,
          strokeWeight: 3,
          fillColor: this.colorArea,
          fillOpacity: 0.9,
        });
      } else {
        this.area = new google.maps.Polygon({
          path: this.path,
          map: this.map,
          id: this.id,
          label: this.label,
          ...AREA_PATH_CONFIG,
        });
      }

      const bounds = new google.maps.LatLngBounds();
      for (let index = 0; index < this.path.length; index++) {
        this.polygonCoords[index] = Object.assign(
          new google.maps.LatLng(this.path[index].lat, this.path[index].lng)
        );
        bounds.extend(this.polygonCoords[index]);
      }

      const marker = new google.maps.Marker({
        position: bounds.getCenter(),
        map: this.map,
        icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 0
        },
        label: {
          color: "#fff",
          fontWeight: "bold",
          text: this.label,
          fontSize: "15px",
        },
      });

      this.marker = marker;

      this.marker.addListener("click", (aplicaciones) => {
        this.agregarAplicacionesStore();
      });

      this.area.addListener("click", (aplicaciones) => {
        this.agregarAplicacionesStore();
      });
    },

    borrarPoligono() {
      this.marker.setMap(null);
      this.area.setMap(null);
    },
    agregarAplicacionesStore() {
      let dataEnviar = {
        aplicacionesNodo: this.aplicaciones,
        etiquetaNodo: this.label,
        idNodo: this.id,
        nombre_asociado: this.nombre_asociado,
        id_asociado: this.id_asociado,
        etiqueta: this.etiqueta,
        fecha: this.fecha,
        tipo: this.tipo,
        id_sig_subobjeto: this.id_sig_subobjeto,
        color: this.color,
      };

      this.$store.commit("aplicaciones/borrarAplicaciones");
      this.$store.commit("aplicaciones/actualizarAplicaciones", dataEnviar);
    },
  },

  destroyed() {
    this.borrarPoligono();
  },

  render() {},
};
</script>
